'use client';

import { ArrowLeft } from 'lucide-react';
import { useParams } from 'next/navigation';

import { useBackNavigation } from '@website/hooks/useBackNavigation';

export function DesktopBackButton() {
  const params = useParams();
  const locale = params?.locale as string;

  const handleBack = useBackNavigation(`/${locale}/search`);

  return (
    <div className="hidden md:block absolute top-[calc(65px+env(safe-area-inset-top)+1rem)] z-20 md:left-14 lg:left-24 xl:left-[calc((100vw-75rem)/2+1rem)]">
      <button
        type="button"
        onClick={handleBack}
        className="flex items-center justify-center size-10 rounded-full bg-white border border-neutral-200 text-neutral-900 shadow-md cursor-pointer hover:bg-neutral-50 hover:shadow-lg transition-all"
        aria-label="Go back"
      >
        <ArrowLeft className="size-5" />
      </button>
    </div>
  );
}
